import { NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppConfigService } from '@core/appconfig.service';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { RoleType } from '@shared/enums/role-type';
import {
  DeleteAllUsersModalOutput,
  DeleteAllUsersModalParams
} from '@shared/manage-users/branded-manage-users/delete-all-users-modal/delete-all-users-modal-types';

@Component({
  selector: 'zbp-delete-all-users-modal',
  imports: [
    ButtonComponent,
    NgTemplateOutlet,
    ReactiveFormsModule
  ],
  templateUrl: './delete-all-users-modal.component.html',
  styleUrl: './delete-all-users-modal.component.scss'
})
export class DeleteAllUsersModalComponent implements OnInit {

  private readonly STEP_1 = 0;
  private readonly STEP_2 = 1;

  static readonly DEFAULT_MODAL_DIALOG_CLASS = 'transparent-bg';
  static readonly DEFAULT_SCHOOL_NAME = 'your school';

  schoolName: string = DeleteAllUsersModalComponent.DEFAULT_SCHOOL_NAME;
  form = new FormGroup({
    teachers: new FormControl(false),
    students: new FormControl(false),
    parents: new FormControl(false),
  });

  private _currentStep: number = 0;

  static open(ngbModal: NgbModal, params: DeleteAllUsersModalParams): NgbModalRef {
    const modalRef = ngbModal.open(
      DeleteAllUsersModalComponent,
      {
        ...params?.options,
        // only use defaults if params does not provide value
        modalDialogClass: params?.options?.modalDialogClass
          ?? DeleteAllUsersModalComponent.DEFAULT_MODAL_DIALOG_CLASS
      }
    );
    const component = modalRef.componentInstance;
    component.schoolName = params.schoolName ?? DeleteAllUsersModalComponent.DEFAULT_SCHOOL_NAME;
    return modalRef;
  }

  constructor(
    private activeModal: NgbActiveModal,
    private appConfig: AppConfigService
  ) {
  }

  ngOnInit() {
    if (this.appConfig.isHighlightsPortalUrl) {
      // for highlights we preselect teachers and then move to the next step
      this.form.controls.teachers.setValue(true);
      this._currentStep = this.STEP_2;
    }
  }

  getTemplateForStep(steps: TemplateRef<any>[]): TemplateRef<any> {
    return steps[this._currentStep];
  }

  hasAnySelected(): boolean {
    return this.form.controls.teachers.value
      || this.form.controls.students.value
      || this.form.controls.parents.value;
  }

  onCancelButtonClick(): void {
    if (this.appConfig.isHighlightsPortalUrl
      || this._currentStep === this.STEP_1) {
      // highlights portal cannot go back to the first step
      this.activeModal.dismiss();
    } else {
      this._currentStep = this.STEP_1;
    }
  }

  getDeleteButtonLabel(): string {
    return this._currentStep === this.STEP_1
      ? 'Delete'
      : 'Yes, Delete';
  }

  onDeleteButtonClick(): void {
    if (this._currentStep === this.STEP_1) {
      this._currentStep = this.STEP_2;
    } else {
      const userRolesToDelete: RoleType[] = [];
      if (this.form.controls.teachers.value) {
        userRolesToDelete.push(RoleType.Teacher);
      }
      if (this.form.controls.students.value) {
        userRolesToDelete.push(RoleType.Student);
      }
      if (this.form.controls.parents.value) {
        userRolesToDelete.push(RoleType.Parent);
      }
      this.activeModal.close({ userRolesToDelete } as DeleteAllUsersModalOutput);
    }
  }
}

